export { default as default } from './Defensora';
